import React, { useEffect, useState } from "react";
import moment from "moment";

import { User } from "lucide-react";

import { IChatMessage } from "../../../types/misc.interface";
import { EChatSource } from "../../../types/entities.enum";

export const ChatMessage = (props: IChatMessage) => {
    const { by, message, timestamp, isTyping, typingEffect, custRef, persona } = props;

    const [messageValue, setMessageValue] = useState<string>('');

    useEffect(() => {
        if (custRef?.current) {
            custRef.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' });
        };
    }, [custRef]);

    useEffect(() => {
        if (message) {
            let interval: NodeJS.Timeout | null = null;

            if (!typingEffect) {
                setMessageValue(message);
            } else {
                interval = setInterval(() => {
                    setMessageValue((prev) => {
                        if (message.length === prev.length + 1) {
                            if (interval) clearInterval(interval);
                            return message;
                        }
                        return message.slice(0, prev.length + 1);
                    });
                }, 40);
            }
            return () => {
                if (interval) clearInterval(interval);
            };
        };

        // eslint-disable-next-line
    }, [message]);

    return (
        <div
            ref={custRef}
            className={`mbts_chat__chat_message mbts_chat__chat_message--from-${by}`}
        >
            <div className='mbts_chat__chat_message__left'>
                <div className='mbts_chat__chat_message__icon'>
                    {/* {by === EChatSource.PERSONA ? <Bot /> : <User />} */}
                    <User />
                </div>
                {timestamp && <p className='text-xs color--txt-muted'>{moment(timestamp).format('HH:mm')}</p>}
            </div>
            <div className='mbts_chat__chat_message__right'>
                <div className='mbts_chat__chat_message__user_info'>
                    {by === EChatSource.PERSONA
                        ? <p className='text-xs'><span className='text-medium'>{persona?.name}</span> <span className='color--txt-muted'>{persona?.role}</span></p>
                        : <p className='text-xs text-medium'>You</p>
                    }
                </div>
                <div className='mbts_chat__chat_message__message_body'>
                    {isTyping && !messageValue && (
                        <div className='mbts_chat__chat_message__message_body__typing_dots'>
                            <div className='mbts_chat__chat_message__message_body__typing_dots__dot' />
                            <div className='mbts_chat__chat_message__message_body__typing_dots__dot' />
                            <div className='mbts_chat__chat_message__message_body__typing_dots__dot' />
                        </div>
                    )}
                    {!isTyping && messageValue && (
                        <p className='text-sm mbts_chat__chat_message__message_body__text'>{messageValue}</p>
                    )}
                </div>
            </div>
        </div>
    );
};